
 
const IS_DEV_MODE = process.env.NODE_ENV === 'development';

export const APP_CONFIG_MODE = {

    APP__IS_NODE_ENV: IS_DEV_MODE,
    APP__IS_LOAD_SEED_TEST: true, // true: ninguna petición a la API. Carga de Seed estática para demostrar.

    APP__SHOW_DEV_BANNER: false, // true: visualizamos banner para dar aviso de que estamos en modo desarrollo  
    APP__DEV_BANNER_MESSAGE: null, // null: usa el texto traducido de _Config/_Translate. Un string acá lo pisa.


    // ------------------------------- 🔥 LOAD SEED (GLOBAL) - NO NIVEL MÓDULO
    SEED: {
        HEADER_EXTRA_1: true,
        HEADER_EXTRA_2: true,
        NAVIGATION_PUBLIC: true,
        NAVIGATION_PRIVATE: true,
        HEADER_UTILITIES_FAVS: true,
        HEADER_UTILITIES_CARTS: true,
        HEADER_UTILITIES_MESSAGES: true,
        HEADER_UTILITIES_NOTIFICATIONS: true,
        HEADER_UTILITIES_MESSAGES_EMAIL: true,
        HEADER_UTILITIES_MESSAGES_WHATSAPP: true,
    },

    // ------------------------------- 🔥 ROLES DEV
    APP__TEST_ROLES_CONFIG: {
        IS_ENABLED: false, ONLY_IN_DEVELOPMENT: IS_DEV_MODE, POSITION: "bottom-right", // bottom-right | bottom-left | top-right | top-left
        START_OPEN: false, // Si arranca abierto al cargar.
        GO_TO_LANDING: true, // Navegar al landing del rol al cambiar.

        ROLES: [
            {
                key: "IT_ADMIN", label: "IT Admin", color: "#7c3aed",
                description: "Superusuario. Ve absolutamente todo, sin comprobar permisos.",
                landing: "/templates", permissions: [],
            },

            {
                key: "ADMIN", label: "Administrador", color: "#e83a52",
                description: "Gestión completa del sistema y del negocio.",
                landing: "/management/hr",
                permissions: [
                    "RRHH__LIST", "RRHH__DETAIL", "RRHH__STATUS", "RRHH__RATES", "RRHH__DELETE",
                    "RRHH__SELECTIONS", "RRHH__LEADS", "RRHH__INTERVIEWS", "RRHH__PLACEMENTS",
                    "RRHH__INVOICES", "RRHH__DOCUMENTS", "RRHH__NOTIF_PREFS",
                ],
            },

            {
                key: "RRHH", label: "Recursos Humanos", color: "#0ea5e9",
                description: "Trabaja con postulantes y entrevistas, pero no toca facturación.",
                landing: "/management/hr",
                permissions: [
                    "RRHH__LIST", "RRHH__DETAIL", "RRHH__STATUS",
                    "RRHH__SELECTIONS", "RRHH__INTERVIEWS", "RRHH__DOCUMENTS",
                ],
            },

            {
                key: "MARKETING", label: "Marketing", color: "#ec4899",
                description: "Campañas, newsletter y blog. No entra a contratación.",
                landing: "/blog-admin",
                permissions: ["MARKETING__LIST", "NEWSLETTER__LIST", "BLOG__LIST"],
            },

            {
                key: "EMPLOYEE", label: "Empleado", color: "#f59e0b",
                description: "Ficha, pide licencias, ve sus recibos y el directorio. Nada de gestión.",
                landing: "/personal", permissions: ["EMPLOYEES__SELF"],
            },

            {
                key: "CLIENT", label: "Cliente", color: "#14b8a6",
                description: "Empresa con contrato. Ve candidatos y pide entrevistas.",
                landing: "/talent",
                permissions: ["RRHH__PORTAL", "RRHH__PORTAL_INTERVIEW"],
            },

            {
                key: "LEAD", label: "Prospecto", color: "#94a3b8",
                description: "Empresa que todavía no cerró, con acceso al portal.",
                realRoleKey: "CLIENT", landing: "/talent",
                permissions: ["RRHH__PORTAL", "RRHH__PORTAL_INTERVIEW"],
            },

            {
                key: "CANDIDATE", label: "Candidato", color: "#a855f7",
                description: "Se postuló y sigue su proceso. Ve si lo eligieron y sus entrevistas.",
                landing: "/my-application", permissions: ["CANDIDATE__SELF"],
            },

            {
                key: "GUEST", label: "Sin sesión", color: "#64748b",
                description: "Visitante anónimo. Solo la parte pública.",
                isGuest: true, landing: "/", permissions: [],
            },
        ],
    },
};

/*
    HELPER encargado de armar lo que el usuario espera del contexto de autenticación. La forma tiene que ser la misma que
    devuelve el login..
*/
export const onBuildSimulatedUser = (role, realUser = null) => {
    if (!role || role.isGuest) return null;

    const ROLE_KEY = role.realRoleKey ?? role.key;

    return {
        ...(realUser ?? {}), id: realUser?.id ?? 0,
        name: realUser?.name ?? "Usuario simulado",
        email: realUser?.email ?? "simulado@local",
        roles: [{ key: ROLE_KEY, permissions: role.permissions.map((p) => ({ key: p })) }],
        permissions: role.permissions, __isSimulated: true, __simulatedRoleKey: role.key,
    };
};


export const DEV_ROLES_CONFIG = APP_CONFIG_MODE.APP__TEST_ROLES_CONFIG;

export const APP_LOAD_ROLES = APP_CONFIG_MODE.APP__TEST_ROLES_CONFIG.ROLES;


const SEED_BLOCK = (isEnabled = false, dataset = null, strategy = null) => ({
    IS_ENABLED: isEnabled, DATASET: dataset, FALLBACK_STRATEGY: strategy,
});

export const APP_LOAD_DATA_MODE = {

    APP_DATA_FALLBACK_STRATEGY: "NOTICE",
    APP_SEED_ONLY_WHEN_SERVER_OK: false,

    LOAD_CONTENT_ENABLED: {
        BLOG_CONTENT: { IS_ENABLED: true },
        PROJECT_CONTENT: { IS_ENABLED: true },
    },

    /*
        🔥 EL SEED DE LA HOME SE PRENDE DESDE SU PROPIA CARPETA

        El interruptor es HOME_SEED_ENABLED, en
        Web/Views/Public/_Home/_Data/HomeSeed.js, al lado de los datos.

        true  → estos bloques usan los valores estáticos de ese archivo
        false → quedan apagados y la home pide todo a la base de datos

        FALLBACK_STRATEGY "SEED" hace que, si el bloque vino vacío, se dibuje
        el dato estático en vez del cartelito de "no hay contenido".
    */
    LOAD_SEED_DEFAULT: {
        BLOG_CONTENT: SEED_BLOCK(false, []),
    },

    LOAD_SEED_HEADER_UTILITIES: {
        NOTIFICATIONS: SEED_BLOCK(false, []),
        MESSAGES: SEED_BLOCK(false, []),
        MESSAGES_EMAIL: SEED_BLOCK(false, []),
        MESSAGES_WHATSAPP: SEED_BLOCK(false, []),
        FAVS: SEED_BLOCK(false, []),
        CARTS: SEED_BLOCK(false, []),
    },

    LOAD_SEED_PUBLIC_NAVIGATION: SEED_BLOCK(false, []),
    LOAD_SEED_PRIVATE_NAVIGATION: SEED_BLOCK(false, []),

};
